import { DEFAULT_AFTER_BUFFER, DEFAULT_BEFORE_BUFFER } from './constants'

export const getInitialValues = ({
  before_buffer_time: beforeBufferTime,
  after_buffer_time: afterBufferTime,
}) => ({
  beforeBuffer: beforeBufferTime?.toString() ?? DEFAULT_BEFORE_BUFFER,
  afterBuffer: afterBufferTime?.toString() ?? DEFAULT_AFTER_BUFFER,
})
